
export class HelpNavigationModule {
    static get Contact(): string { return `${HelpNavigationModule.ParentRoot}.contact`; }

    static get Default(): string { return HelpNavigationModule.Contact; }
    static get ParentRoot(): string { return "app.help"; }
}
